import React from 'react';
export const AgreementsLiner18 = _ref => {
  let {
    size = 18
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.18753C3 3.18753 3 3.18753 3 6.18753V13.5C3 16.5 3 16.5 6 16.5H12C15 16.5 15 16.5 15 13.5V6.18753C15 3.18753 15 3.18753 12 3.18753M6 3.18753C6 3.65253 6.18748 4.07253 6.49498 4.38003C6.80248 4.68753 7.2225 4.87503 7.6875 4.87503H10.3125C11.2425 4.87503 12 4.11753 12 3.18753M6 3.18753C6 2.25753 6.7575 1.50003 7.6875 1.50003H10.3125C10.7775 1.50003 11.1975 1.68753 11.505 1.99503C11.8125 2.30253 12 2.72253 12 3.18753M6.99988 11.5L8.49988 12.5L10.9999 9.50003",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};